import { Flex } from '@chakra-ui/react';
import Spinner from '@/components/Spinner';

export default function Fallback() {
  return (
    <Flex h='80vh' justify='center' align='center'>
      <Spinner loading={true} />
    </Flex>
  );
}
